export default {
      id: "actualData-usage",
      viewBox: "0 0 57 48",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#actualData-usage",
      toString: function () {
        return this.url;
      }
    }